import {Ease} from "../../core/Animatable";
import {Callback} from "../../core/Reflection";
import {SceneItem} from "../SceneItem";
import {Animation} from "./Animation";
import {AnimationContext} from "./AnimationContext";

export class ScaleUpAnimation extends Animation {
    public animate(item: SceneItem, context: AnimationContext, cb: Callback): void {
        const isSquishStretch = this.ease === "squishStretch";
        const sx = isSquishStretch ? 1 : 0.1;
        const sy = isSquishStretch ? 0.6 : 0.1;
        const appear = this.appear && this.delay;
        item.tweenFrom(this.time || 1, this.getEase(Ease.backOut), {
            scaleX: item.scale.x * sx,
            scaleY: item.scale.y * sy,
            delay: this.delay,
            onStart: appear ? () => {
                item.paperCutVisible(true);
                item.alpha = 1;
            } : undefined,
            onUpdate: () => {
                this.updatePaperCut(item);
                this.onUpdate();
            },
            onComplete: () => {
                this.onComplete();
                cb();
            },
        });
        if (appear) {
            item.alpha = 0;
            item.paperCutVisible(false);
        } else if (this.delay) {
            this.updatePaperCut(item);
        }
    }
}
